const RICOS_VERSION = "10.130.0";
export {
  RICOS_VERSION
};
//# sourceMappingURL=version.js.map
